import type { HTMLAttributes, ReactNode } from "react";
import styles from "./Card.module.css";

interface CardProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  /** Remove body padding — for tables and charts that run edge to edge. */
  flush?: boolean;
}

export function Card({ title, description, actions, flush, children, className, ...rest }: CardProps) {
  return (
    <section className={[styles.card, className].filter(Boolean).join(" ")} {...rest}>
      {(title || actions) && (
        <header className={styles.header}>
          <div className={styles.titles}>
            {title && <h2 className={styles.title}>{title}</h2>}
            {description && <p className={styles.description}>{description}</p>}
          </div>
          {actions && <div className={styles.actions}>{actions}</div>}
        </header>
      )}
      <div className={flush ? styles.flush : styles.body}>{children}</div>
    </section>
  );
}
